const breakpoints = {
  mobile: 500,
}

export const mobileScreen = `@media only screen and (max-width: ${breakpoints.mobile}px)`
